class ReviewsSorting {
	constructor() {
		this.init();
	}

	init() {
		this.initReviewShorting();
	}

	initReviewShorting() {
		const checkbox 	= $('#fistImages'),
			  url 		= new URL(location.href),
			  rURL 		= `//${url.host}${url.pathname}?imagesFirst=`;

		$(checkbox).on('change', () => {
			if ($(checkbox).is(':checked')) {
				window.location.href = `${rURL}true`;
			} else {
				window.location.href = `${rURL}false`;
			}
		});
	}
}

export default ReviewsSorting;